import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../core/i18n'
import { tourService, userService } from '../../../core/services'
import * as constants from '../../../static/constants'
import { CheckBox, Select } from '../../atoms'
import SvgIcon from 'components/atoms/SvgIcon'

import Typography from 'components/atoms/_layouts/Typography'
import { IUser } from '../../../static/interfaces'
import MessageLink from 'components/organisms/MessageLink'
import MessageIndexLayout from '../_layouts/messageIndexLayout'
import TextClamp from 'components/atoms/TextClamp'
import moment from 'moment'

interface IProps {
  user: IUser
  tours: any
  non_assigned_reservation_count: number
}
const Filter: React.VFC<IProps> = ({ non_assigned_reservation_count }) => {
  const getShowUnassignedReservation = () => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('non_assigned_only') === 'true'
  }

  const showOnlyUnassignedReservationHandler = event => {
    const currentUrlParams = new URLSearchParams(window.location.search)
    if (event.target.checked) {
      currentUrlParams.set('non_assigned_only', 'true')
    } else {
      currentUrlParams.delete('non_assigned_only')
    }
    currentUrlParams.set('page', '1')

    location.href = `conversations?${currentUrlParams.toString()}`
  }
  const getShowAlreadyHeldReservation = () => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('held_only') || '' // === 'true'
  }

  const showOnlyAlreadyHeldReservationHandler = event => {
    const currentUrlParams = new URLSearchParams(window.location.search)
    if (event.target.value === 'true') {
      currentUrlParams.set('held_only', 'true')
    } else if (event.target.value === 'false') {
      currentUrlParams.set('held_only', 'false')
    } else {
      currentUrlParams.delete('held_only')
    }
    currentUrlParams.set('page', '1')

    location.href = `conversations?${currentUrlParams.toString()}`
  }
  return (
    <GuideAgentFilters>
      <div className="filters">
        {non_assigned_reservation_count > 0 && (
          <CheckBox
            name="non_assigned_only"
            label={I18n.t('reservation.unassigned_tour_only', {
              count: non_assigned_reservation_count,
            })}
            defaultChecked={getShowUnassignedReservation()}
            onChangeHandler={showOnlyUnassignedReservationHandler}
            showLabelInline={true}
          />
        )}
        <Select
          name="held_tours_only"
          options={FILTER_OPTIONS.map(option => ({
            label: option.label,
            value: option.value,
          }))}
          defaultValue={getShowAlreadyHeldReservation()}
          onChangeHandler={showOnlyAlreadyHeldReservationHandler}
        />
      </div>
    </GuideAgentFilters>
  )
}
export const FILTER_OPTIONS = [
  { value: '', label: I18n.t('reservation.all_reservations') },
  { value: 'true', label: I18n.t('reservation.held_reservations_only') },
  { value: 'false', label: I18n.t('reservation.ongoing_reservations_only') },
]

const MessagesIndex: React.FC<IProps> = props => {
  const { data: tours, pagination: pagination } = tourService.getDataFromJson(props.tours.records)
  const { user } = userService.getUserFromJson(props.user)
  const getStateIcon = item => {
    const date =
      I18n.locale === 'en' ? moment(item.start_at) : moment(item.start_at, 'YYYY年MM月DD日 HH:mm')
    if (date.isBefore(moment())) {
      return 'event_available'
    }
    if (item.assignment_status === 'assigned') {
      return 'perm_contact_calendar'
    } else {
      return 'calendar_today'
    }
  }
  const getMessageLink = (conversation, type) => {
    if (!conversation.latest_message) {
      return null
    }
    return <MessageLink user={user} conversation={conversation} type={type} key={conversation.id} />
  }

  const DefaultMessage = (item, conversation) => {
    const type = item.post.user.guide ? 'with_guide' : 'with_agent'
    return getMessageLink(conversation, type)
  }

  const GuideMessage = conversation => {
    return getMessageLink(conversation, 'with_members')
  }

  return (
    <MessageIndexLayout user={user} filter={<Filter {...props} />} pagination={pagination}>
      {tours.map(item => (
        <ReservationsConversations key={item.id}>
          <div className="Reservations_conversations-header">
            <div className="tour_name">
              <TextClamp line={1}>{item.post.name}</TextClamp>
              <SvgIcon
                name={getStateIcon(item)}
                className="icon"
                ariaHidden={true}
                role="presentation"
              />
            </div>
            <div className="tour_dates">
              <Typography type="body" size="lg" color="subtext">
                {I18n.t('generic.time_schedule')}: {item.start_at}-{item.end_at}
              </Typography>
            </div>
          </div>
          {item.reservation_conversations.map(conversation => DefaultMessage(item, conversation))}
          {item.tour_group_conversations.map(conversation => GuideMessage(conversation))}
        </ReservationsConversations>
      ))}
    </MessageIndexLayout>
  )
}

const GuideAgentFilters = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px 0;
  margin-bottom: 24px;
  .filters {
    display: flex;
    flex-direction: column;
    .CheckBox {
      margin: 5px 0;
    }
  }
`

const ReservationsConversations = styled.div`
  margin-bottom: 16px;

  & + & {
    margin-top: 16px;
  }

  .Reservations_conversations-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 0;
    gap: 4px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      flex-direction: column;
      align-items: flex-start;
    }
    .tour_name {
      display: flex;
      align-items: center;
      margin-right: 32px;
      @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
        margin-right: 0;
      }
      .icon {
        margin-left: 4px;
      }
    }

    .tour_dates {
      flex-shrink: 0;
    }
  }
`

export default MessagesIndex
